import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'
import VueCarousel from 'vue-carousel'
import VueTippy from 'vue-tippy'
import VueContentPlaceholders from 'vue-content-placeholders'
import Vueditor from 'vueditor'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import axios from 'axios'
import VueisOffLine from 'vue-isoffline'
import FileUpload from 'v-file-upload'
import VueSSE from 'vue-sse'
import VCharts from 'v-charts'
import VueFrappe from 'vue2-frappe'
import VueApexCharts from 'vue-apexcharts'
import VueRx from 'vue-rx'
import VueFusionCharts from 'vue-fusioncharts'
import FusionCharts from 'fusioncharts'
import Column2D from 'fusioncharts/fusioncharts.charts'
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'
import jsPDF from 'jspdf'
import Pivot from '@marketconnect/vue-pivot-table'
import PivotTable from '@marketconnect/vue-pivot-table'
import VueAnalytics from 'vue-ua'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
// import { LogUrls } from './vuex/Logs/urls'




import menu from '../src/mixins/Functions/Menu'
// import VueCSV from 'vuecsv'
import 'vue-loaders/dist/vue-loaders.css'
import * as VueLoaders from 'vue-loaders'
import VueInstagram from 'vue-instagram'
import VueClipboard from 'vue-clipboard2'

// import myWorker from 'worker-loader?./myworker'
// let worker = new Worker(myWorker);
// const worker = new Worker();

// worker.postMessage({ a: 1 });
// worker.onmessage = function (event) {};

// worker.addEventListener("message", function (event) {});
Vue.config.productionTip = false
Vue.use(VueMomentJS, moment)
Vue.use(VueCarousel)
Vue.use(VueTippy)
Vue.use(VueSSE)
Vue.use(VueRx)
Vue.use(VueContentPlaceholders)
Vue.use(VueisOffLine)
Vue.use(FileUpload)
Vue.use(require('vue-chartist'))
Vue.use(VCharts)
Vue.use(VueApexCharts)
Vue.use(VueFusionCharts, FusionCharts, Column2D, FusionTheme)
Vue.use(VueFrappe)
Vue.use(VueLoaders)
Vue.use(jsPDF)
Vue.use(VueInstagram)
Vue.use(VueClipboard)
Vue.use(Pivot, PivotTable)
Vue.use(VueFacebookPixel)
Vue.use(VueAnalytics, {
	// [Required] The name of your app as specified in Google Analytics.
	appName: 'OBTS',
	// [Required] The version of your app.
	appVersion: '1.3.10',
	// [Required] Your Google Analytics tracking ID.
	trackingId: 'AW-942857980',
	// If you're using vue-router, pass the router instance here.
	vueRouter: router
})
Vue.use(Vuetify, {
	theme: {
		musk: '#520036',
		primary: '#73a533',
		secondary: '#42A5F5',
		accent: '#8c9eff',
		warning: '#ea691f',
		error: '#E53935',
		yellow: '#fdbzz813',
		orange: '#e67e22'
	}
})
Vue.component('apexchart', VueApexCharts)
// Vue.component('csv-download', VueCSV)
// Mixins
Vue.mixin(require('./mixins/Computed/Finance/FinanceExport'))
Vue.mixin(require('./mixins/Computed/Booking/BookingExport'))
Vue.mixin(require('./mixins/Computed/Facility/FacilityExport'))
Vue.mixin(require('./mixins/Computed/Inventory/InventoryExport'))
Vue.mixin(require('./mixins/Computed/Membership/MembershipExport'))
Vue.mixin(require('./mixins/Computed/Settings/SettingsExport'))
Vue.mixin(require('./mixins/Computed/Staff/StaffExport'))
Vue.mixin(require('./mixins/Computed/Users/UsersExport'))
Vue.mixin(require('./mixins/Computed/Volunteer/VolunteerExport'))
Vue.mixin(require('./mixins/Computed/ComputedExport'))
Vue.mixin(require('./mixins/Functions/FunctionsExport'))
Vue.mixin(require('./mixins/Computed/PromoCodes/PromoExport'))
Vue.mixin(require('./mixins/Computed/RChartsVuex'))

// If using mini-toastr, provide additional configuration
const toastTypes = {
	success: 'success',
	error: 'error',
	info: 'info',
	warn: 'warn'
}

// Vue Editor
// your config here
let config = {
	toolbar: [
		'removeFormat', 'undo', '|', 'elements', 'fontName', 'fontSize', 'foreColor', 'backColor', 'divider',
		'bold', 'italic', 'underline', 'strikeThrough', 'links', 'divider', 'subscript', 'superscript',
		'divider', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', '|', 'indent', 'outdent',
		'insertOrderedList', 'insertUnorderedList', '|', 'tables', '|', 'switchView'
	],
	fontName: [
		{ val: 'arial black' },
		{ val: 'times new roman' },
		{ val: 'Courier New' }
	],
	fontSize: ['12px', '14px', '16px', '18px', '0.8rem', '1.0rem', '1.2rem', '1.5rem', '2.0rem'],
	uploadUrl: ''
}
Vue.use(Vueditor, config)

miniToastr.init({ types: toastTypes })

// Here we setup messages output to `mini-toastr`
function toast({ title, message, type, timeout, cb }) {
	return miniToastr[type](message, title, timeout, cb)
}

// Binding for methods .success(), .error() and etc. You can specify and map your own methods here.
// Required to pipe our output to UI library (mini-toastr in example here)
// All not-specified events (types) would be piped to output in console.
const options = {
	success: toast,
	error: toast,
	info: toast,
	warn: toast
}

Vue.use(VueNotifications, options)// VueNotifications have auto install but if we want to specify options we've got to do it manually.

// Add a request interceptor
axios.interceptors.request.use(function (config) {
	store.dispatch('loading_true')
	// Do something before request is sent
	config.responseType = 'json'
	// if (config.url === 'https://bookings.olpejetaconservancy.org:9000/v1/user/single') {
	let tracker = JSON.parse(localStorage.getItem('unem'))
	if (tracker === null) {
		tracker = { 'tracker_id': 'UsIUkFDNUL4wm2AGbZoPoNzXGHgzlXKcJFk9M3J2iP_jOB30dtVK24NjOjdN_d5052lUg_udIoPhftpsHtOYqQ' }
	} else {
		tracker = tracker
	}
	config.headers = {
		'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
		'X-Api-Key': 'UsIUkFDNUL4wm2AGbZoPoNzXGHgzlXKcJFk9M3J2iP_jOB30dtVK24NjOjdN_d5052lUg_udIoPhftpsHtOYqQ',
		'tracker_id': tracker.tracker_id
	}

	if ((config.method === 'post' || config.method === 'put' || config.method === 'patch') && localStorage.getItem('lkjhgfdsa') !== null) {
		if (config.data === undefined) {
			config.data = {}
			config.data = Object.assign(config.data,
				{
					session_id: localStorage.getItem('lkjhgfdsa')
				}
			)
		} else {
			config.data = Object.assign(config.data, {
				session_id: localStorage.getItem('lkjhgfdsa')
			})
		}
	}
	if ((config.method === 'post' || config.method === 'put' || config.method === 'patch') && localStorage.getItem('lkjhgfdsa') === null) {
		config.data = Object.assign(config.data, {
			session_id: 'guest'
		})
	}
	// store.dispatch("post_system_log", config);
	// save_cofig(config)
	return config
}, function (error) {
	return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
	store.dispatch('loading_false')
	// Do something with response data
	if (response.status < 400) {
		if (response.data.message) {
			VueNotifications.info({ message: response.data.message })
		}
	}
	return response
}, function (error) {
	store.dispatch('loading_false')
	// Do something with response error
	if (error.hasOwnProperty('response')) {

		let error_jsonified = JSON.parse(error.request.response)

		if (error_jsonified.hasOwnProperty('message')) {

			VueNotifications.error({ message: error_jsonified.message })
		}
		if (error_jsonified.hasOwnProperty('messages')) {

			for (var i = 0; error_jsonified.messages.length > i; i++) {
				VueNotifications.error({ message: error_jsonified.messages[i] })
			}
		}
	}
	return Promise.reject(error)
})

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		let unem = JSON.parse(localStorage.getItem('unem'))
		if (!unem) {
			next({
				path: '/login'
			})
		} else {
			let menuItems = []
			for (var single in unem.menu) {
				for (var eachFeature in unem.menu[single].features) {
					menuItems.push(unem.menu[single].features[eachFeature].url)
				}
			}
			menuItems.push('Booking')
			menuItems.push('Receipt')
			menuItems.push('PartnerReceipt')
			menuItems.push('GroupBooking')
			menuItems.push('GatePayment')
			menuItems.push('Checkin')
			menuItems.push('Roles')
			menuItems.push('Facility')
			menuItems.push('EditFacility')
			menuItems.push('SingleInventory')
			menuItems.push('EditInventory')
			menuItems.push('Member')
			menuItems.push('Visitor')
			menuItems.push('Partner')
			menuItems.push('EditPartner')
			menuItems.push('User')
			menuItems.push('MVolunteerProgram')
			menuItems.push('EditProgram')
			menuItems.push('Donation')
			menuItems.push('PromoCodeUsage')
			menuItems.push('BookingsInspection')
			menuItems.push('BookingInspection')
			menuItems.push('BookingsBan')
			menuItems.push('ConservationVehicleCalendar')
			menuItems.push('PendingPartnerBooking')
			menuItems.push('PendingGroupBooking')
			menuItems.push('PublicUsers')
			menuItems.push('PublicUser')
			menuItems.push('Payments')

			if (menuItems.includes(to.name)) {
				next()
			} else {
				next({
					path: '/login'
				})
			}
		}
	} else {
		next()
	}
})



new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
